import PagamentoLoteAprovacaoComponent from "../../components/pagamento-lote/aprovacao/PagamentoLoteAprovacao";

export default function PagamentoLoteAprovacao() {
  return <PagamentoLoteAprovacaoComponent />;
}
